import React, { useEffect } from 'react'

import TeamsDraw from './TeamsDraw';
import AddManualTeam from './AddManualTeam'
import AllGeneratedTeamsRound from '../Templates/AllGeneratedTeamsRound'

function GeneratedTeamsRound({id, roundId, round, players, requestCount, setRequestCount, setActiveItem}) {

    useEffect(() => {

        console.log(players, "players")

    }, [players])

    return (
        <React.Fragment>
            {round && (
                <AllGeneratedTeamsRound 
                    id={id}
                    roundId={roundId}
                    roundData={round}
                    registeredPlayers={players}
                />
            )}
            {players.length && <AddManualTeam draw="1" players={players} roundId={roundId} hostcupId={id} />}
            {players && 
                <TeamsDraw
                    registeredPlayers={players} 
                    id={id} 
                    roundId={roundId} 
                    requestCount={requestCount} 
                    setRequestCount={setRequestCount} 
                    round={round}
                    setActiveItem={setActiveItem}
                />
            }
        </React.Fragment>
    )
}
export default GeneratedTeamsRound